import Action from 'actions';
import BaseExecutor from 'services/sports/default/base-executor';
import BaseValidator from 'services/validations/base-validator';
import {FightStackingValidatorBuilder} from 'services/sports/mma/validator/fight-stacking-validator-builder';
import {MinAdjustedPlayersValidatorBuilder} from 'services/sports/draftkings/validator/min-adjusted-players-validator-builder';
import ProjectedOwnershipForceValidator from 'components/organisms/projected-ownership-force/validators/validator';
import {ClassicValidatorBuilder} from 'services/validations/builders/classic-validator-builder';

export default class UserAdjustmentsValidatorBuilder extends BaseExecutor {
    getInterface() {
        const {
            sportConfig,
            competitionStacking: stacking,
            userPointsType,
            projectedOwnershipForce,
            playersData: {preparedPlayers},
        } = Action.getState();

        const validator = new BaseValidator();

        const classicValidatorBuilder = new ClassicValidatorBuilder().getInterface();
        validator.addSubValidators([classicValidatorBuilder]);

        if (projectedOwnershipForce.isEnabled()) {
            const projectedOwnershipForceValidator = new ProjectedOwnershipForceValidator();
            projectedOwnershipForceValidator.setDependencies({
                sportConfig,
                projectedOwnershipForce,
                players: preparedPlayers.groupedBy.playerId(),
            });
            validator.addSubValidators([projectedOwnershipForceValidator]);
        }

        if (stacking.isEnabled()) {
            const fightStackingValidator = new FightStackingValidatorBuilder().getInterface();
            validator.addSubValidators([fightStackingValidator]);
        }

        if (!this._isAnyStackingUsed()) {
            const minAdjustedPlayersValidator = new MinAdjustedPlayersValidatorBuilder({
                propNameOfDefaultUserPointsValue: userPointsType.getUserPointsType(),
            }).getInterface();
            validator.addSubValidators([minAdjustedPlayersValidator]);
        }

        return validator;
    }

    _isAnyStackingUsed() {
        return this._isPlayerCombinationStackingUsed() || this._isCompetitionStackingUsed();
    }

    _isPlayerCombinationStackingUsed() {
        const {playerCombinationStacking} = Action.getState();

        return playerCombinationStacking.isEnabled() && playerCombinationStacking.hasItems();
    }

    _isCompetitionStackingUsed() {
        const {competitionStacking} = Action.getState();

        return competitionStacking.isEnabled() && competitionStacking.hasItems();
    }
}
